import { render, staticRenderFns } from "./FulfilmentInventory.vue?vue&type=template&id=4ee4e20b&scoped=true&"
import script from "./FulfilmentInventory.vue?vue&type=script&lang=js&"
export * from "./FulfilmentInventory.vue?vue&type=script&lang=js&"
import style0 from "./FulfilmentInventory.vue?vue&type=style&index=0&id=4ee4e20b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee4e20b",
  null
  
)

export default component.exports